import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45c1173f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "guild-navigation",
  class: "full-height-section"
}
const _hoisted_2 = { class: "guild-header" }
const _hoisted_3 = { class: "guild-ctas flex flex-row gap-3 mt-3" }
const _hoisted_4 = { class: "guild-ctas flex flex-row gap-3 mt-3" }
const _hoisted_5 = { class: "groups" }
const _hoisted_6 = { class: "group" }
const _hoisted_7 = { class: "group-header flex flex-row flex-grow-1" }
const _hoisted_8 = { class: "channel-ctas ml-auto flex flex-row gap-1 justify-content-end" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1))
const _hoisted_11 = [
  _hoisted_10
]

import { ref, watch } from 'vue';
import { useGuildStore } from '@/stores/GuildStore';
import { useDialogStore } from '@/stores/DialogStore';
import { Channel, ChannelGroup } from '@/models/channel-list.model';
import Button from 'primevue/button';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import GuildDelete from './GuildDelete.vue';
import GuildChannelGroupCreate from './Channels//GuildChannelGroupCreate.vue';
import GuildChannelGroupEdit from './Channels/GuildChannelGroupEdit.vue';
import GuildChannelGroupDelete from './Channels/GuildChannelGroupDelete.vue';
import GuildChannelCreate from './Channels/GuildChannelCreate.vue';
import GuildChannelEdit from './Channels/GuildChannelEdit.vue';
import GuildChannelDelete from './Channels/GuildChannelDelete.vue';
import GuildEdit from './GuildEdit.vue';
import ContextMenu from 'primevue/contextmenu';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildNavigation',
  setup(__props) {

const guildStore = useGuildStore();
const dialogStore = useDialogStore();
const groupsIndexes = ref<number[]>([]);

// Guild header context menu ----------------------------------------
const guildHeaderMenu = ref();
const guildHeaderMenuItems = ref([
  {
    label: 'Edit Guild',
    icon: 'pi pi-pencil',
    command: () => onEditGuild()
  },
  {
    label: 'Delete Guild',
    icon: 'pi pi-trash',
    command: () => onDeleteGuild()
  },
]);

const onGuildHeaderClick = (event: Event) => {
  guildHeaderMenu.value.show(event);
};

// Group and channel context menu ----------------------------------------
const groupMenu = ref();
const groupMenuItems = ref([
  {
    label: 'Edit Group',
    icon: 'pi pi-pencil',
    command: () => onEditGroup()
  },
  {
    label: 'Delete Group',
    icon: 'pi pi-trash',
    command: () => onDeleteGroup()
  },
]);
const selectedGroup = ref<ChannelGroup>();

const onGroupHeaderClick = (event: Event, group: ChannelGroup) => {
  selectedGroup.value = group;
  groupMenu.value.show(event);
}

// Channel context menu ----------------------------------------
const channelMenu = ref();
const channelMenuItems = ref([
  {
    label: 'Edit channel',
    icon: 'pi pi-pencil',
    command: () => onEditChannel()
  },
  {
    label: 'Delete channel',
    icon: 'pi pi-trash',
    command: () => onDeleteChannel()
  },
]);
const selectedChannel = ref<Channel>();
const onChannelMenuClick = (event: Event, group: ChannelGroup, channel: Channel) => {
  selectedGroup.value = group;
  selectedChannel.value = channel;
  channelMenu.value.show(event);
}

function onEditGuild(){
  dialogStore.openDialog(GuildEdit, 'Edit this guild');
}

function onDeleteGuild(){
  dialogStore.openDialog(GuildDelete, 'Are you sure you want to delete this guild?');
}

function onCreateChannelGroup(){
  dialogStore.openDialog(GuildChannelGroupCreate, 'Create a new channel group');
}

function onEditGroup(){
  if(selectedGroup.value){
    dialogStore.openDialog(GuildChannelGroupEdit, 'Edit this group', { group: selectedGroup.value });
  } else {
    console.error('No group selected');
  }
}

function onDeleteGroup(){
  if(selectedGroup.value){
    dialogStore.openDialog(GuildChannelGroupDelete, 'Are you sure you want to delete this group?', { channelGroupId: selectedGroup.value.id });
  } else {
    console.error('No group selected');
  }
}

function onCreateChannel(group: ChannelGroup){
  if(group){
    dialogStore.openDialog(GuildChannelCreate, 'Create a new channel', { group });
  } else {
    console.error('No group selected');
  }
}

function onEditChannel(){
  if(selectedGroup.value && selectedChannel.value){
    dialogStore.openDialog(GuildChannelEdit, 'Edit this channel', { groupId: selectedGroup.value.id, channel: selectedChannel.value });
  } else {
    console.error('No group or channel selected');
  }
}

function onDeleteChannel(){
  if(selectedGroup.value && selectedChannel.value){
    dialogStore.openDialog(GuildChannelDelete, 'Are you sure you want to delete this channel?', { channelGroupId: selectedGroup.value?.id, channelId: selectedChannel.value?.id });
  } else {
    console.error('No group or channel selected');
  }
}

watch(() => guildStore.channelsList?.groups, (newGroups, oldGroups) => {
  if (newGroups !== oldGroups && newGroups != null) {
    const activeIndex = newGroups.map((group, index) => index);
    groupsIndexes.value = activeIndex;
  }
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(guildStore).guild && _unref(guildStore).loaded)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_unref(guildStore).guild.name), 1),
            (_unref(guildStore).isOwner)
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  icon: "pi pi-ellipsis-v",
                  size: "small",
                  class: "ml-auto",
                  text: "",
                  plain: "",
                  onClick: onGuildHeaderClick
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(ContextMenu), {
              ref_key: "guildHeaderMenu",
              ref: guildHeaderMenu,
              model: guildHeaderMenuItems.value
            }, null, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (!_unref(guildStore).isMember)
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  label: "Join Guild",
                  size: "small",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(guildStore).joinGuild()))
                }))
              : (_openBlock(), _createBlock(_unref(Button), {
                  key: 1,
                  label: "Leave Guild",
                  size: "small",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(guildStore).leaveGuild()))
                }))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(Accordion), {
              multiple: true,
              activeIndex: groupsIndexes.value,
              expandIcon: "pi pi-chevron-up",
              collapseIcon: "pi pi-chevron-up"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(guildStore).channelsList?.groups, (group) => {
                  return (_openBlock(), _createBlock(_unref(AccordionTab), {
                    key: group.id
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("small", null, _toDisplayString(group.name), 1),
                        (_unref(guildStore).isOwner)
                          ? (_openBlock(), _createBlock(_unref(Button), {
                              key: 0,
                              icon: "pi pi-ellipsis-v",
                              size: "small",
                              text: "",
                              plain: "",
                              class: "p-0 ml-auto",
                              onClick: ($event: any) => (onGroupHeaderClick($event, group))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_unref(guildStore).isOwner)
                          ? (_openBlock(), _createBlock(_unref(Button), {
                              key: 1,
                              icon: "pi pi-plus",
                              size: "small",
                              text: "",
                              plain: "",
                              class: "p-0",
                              onClick: ($event: any) => (onCreateChannel(group))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.channels, (channel) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "channel flex flex-row align-items-center gap-2",
                          key: channel.id
                        }, [
                          _createVNode(_component_router_link, {
                            class: "channel",
                            to: { name: 'guild', params: { channelId: channel.id }}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(channel.getChannelIcon()),
                                style: {"font-size":"0.95rem"}
                              }, null, 2),
                              _createTextVNode(" - " + _toDisplayString(channel.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _createElementVNode("div", _hoisted_8, [
                            (_unref(guildStore).isOwner)
                              ? (_openBlock(), _createBlock(_unref(Button), {
                                  key: 0,
                                  icon: "pi pi-ellipsis-v",
                                  size: "small",
                                  text: "",
                                  plain: "",
                                  class: "p-0 ml-auto",
                                  onClick: ($event: any) => (onChannelMenuClick($event, group, channel))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["activeIndex"]),
            _createVNode(_unref(ContextMenu), {
              ref_key: "groupMenu",
              ref: groupMenu,
              model: groupMenuItems.value
            }, null, 8, ["model"]),
            _createVNode(_unref(ContextMenu), {
              ref_key: "channelMenu",
              ref: channelMenu,
              model: channelMenuItems.value
            }, null, 8, ["model"])
          ])
        ]),
        _createVNode(_unref(Button), {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onCreateChannelGroup()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Create channel group")
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
}
}

})